import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  formField: { marginBottom: theme.spacing(2) },
  actions: { marginTop: theme.spacing(2), display: "flex", gap: theme.spacing(1), justifyContent: "flex-end" },
  dialogPaper: {
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    minHeight: 0,
    overflow: "hidden"
  },
  dialogContent: {
    overflowY: "auto",
    flex: "1 1 auto"
  }
}));
